import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

//LOGIN CUSTOMER
export const customerLogin = createAsyncThunk(
  "client/login-Customer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}vancouverapis/webapp/customers/api/v1/login-Customer`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },withCredentials: true
        }
      );
      if (response.data?.authToken) {
        localStorage.setItem("authToken", response.data.authToken); // Store token
        const userRowId = response.data.customerRes?.[0]?.ROWID;
        if (userRowId) {
          localStorage.setItem("customerId", userRowId);
        } else {
          console.error("UserRowId is undefined");
        }
      }

      console.log("Signin API Response:", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);

// export const customerLogin = async (data) => {
//     // console.log("cart form data ---- ", data);
//     const token = localStorage.getItem("authToken");
//     try {
//         const response = await axios.post(`${baseUrl}vancouverapis/webapp/customers/api/v1/login-Customer`, data, {
//             headers: {
//                 "auth-token": token,
//             }, withCredentials: true
//         });
//         if (response.data?.authToken) {
//             localStorage.setItem("authToken", response.data.authToken); // Store token
//             const userRowId = response.data.customerRes?.[0]?.ROWID;
//             if (userRowId) {
//                 localStorage.setItem("UserRowId", userRowId); // Store ROWID
//             } else {
//                 // console.error("UserRowId is undefined");
//             }
//         }
//         return response; // ✅ Return only the data
//     } catch (error) {
//         console.error("Error while Login:", error);

//         // ✅ Handle errors properly
//         throw error; // Return the error for further handling
//     }
// };

//SIGNUP CUSTOMER

export const customerRegister = async (data) => {
    // console.log("cart form data ---- ", data);
    const token = localStorage.getItem("authToken");
    try {
        const response = await axios.post(`${baseUrl}vancouverapis/webapp/customers/api/v1/signup-Customer`, data, {
            headers: {
                "auth-token": token,
            },
        });
        // console.log("add to cart response ", response);
        return response; // ✅ Return only the data
    } catch (error) {
        console.error("Error while Signup:", error);

        // ✅ Handle errors properly
        throw error; // Return the error for further handling
    }
};

//VERIFY CUSTOMER

export const verifyCustomerWithOtp = async (data) => {
    // console.log("cart form data ---- ", data);
    const token = localStorage.getItem("authToken");
    try {
        const response = await axios.post(`${baseUrl}vancouverapis/webapp/customers/api/v1/verify-Customer`, data, {
            headers: {
                "auth-token": token,
            },
        });
        // console.log("add to cart response ", response);
        return response; // ✅ Return only the data
    } catch (error) {
        console.error("Error while Signup:", error);

        // ✅ Handle errors properly
        throw error; // Return the error for further handling
    }
};

export const logoutCustomer = async (data) => {
    // console.log("cart form data ---- ", data);
    const token = localStorage.getItem("authToken");
    try {
        const response = await axios.get(`${baseUrl}vancouverapis/webapp/signout`, data, {
            headers: {
                "auth-token": token,
            },
        });
        // console.log("add to cart response ", response);
        return response; // ✅ Return only the data
    } catch (error) {
        console.error("Error while Signup:", error);

        // ✅ Handle errors properly
        throw error; // Return the error for further handling
    }
};